import genererGuid from '@/services/general/genererGuid';

export default function genererEncartCheminFer(pageId, ligneCommande) {
  return {
    id: genererGuid(),
    isCreate: true,
    pageParutionId: pageId,
    largeur: ligneCommande?.ligneEncart?.largeur || 105,
    hauteur: ligneCommande?.ligneEncart?.hauteur || 180,
    decalageMargeHaut: 0,
    decalageMargeGauche: 0,
    ratio: ligneCommande?.ligneEncart?.ratio || 0,
    ligneEncartId: ligneCommande?.ligneEncart?.id || null,
    ligneRegroupementId: ligneCommande?.id || null,
    libelleRegroupement: ligneCommande?.lignePresse?.libelle || '',
    libelleEncart: ligneCommande?.ligneEncart?.libelle || null,
  };
}
